import { createFileRoute } from '@tanstack/react-router'
import { StaffKepegawaian } from '../../../../components/StaffKepegawaian'
import { useStaffUsers } from '../../../../hooks/useApi'

export const Route = createFileRoute('/desa/$slug/dashboard/kepegawaian')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    const { data: staffData } = useStaffUsers(desaId)
    if (!desaId) return null
    const approvedStaff = (staffData?.data ?? []).filter((u: any) => u.status === 'approved')
    return <StaffKepegawaian desaId={desaId} staff={approvedStaff} />
  },
})
